import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=1021f26c&"
import script from "./MobileMenuButton.vue?vue&type=script&lang=ts&"
export * from "./MobileMenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports